import React, { useEffect } from 'react';
import EArchivePatientList from '../../EArchivePatientList/EArchivePatientList';
import { View } from '../../../../../Enums/View.enum';
import {
	GroupDetailMembersQuery,
	useGroupDetailMembersQuery,
} from '../../../../../graphql/graphql';
import { useFlatDataList } from '../../../../Base/Hooks/useFlatDataList';

interface Props {
	groupId: string;
	groupType?: string;
}

type GroupMember = NonNullable<
	NonNullable<GroupDetailMembersQuery['groupMembers']>['data']
>[number];

const EArchiveGroupMembersList = ({ groupId, groupType }: Props) => {
	const { flatData, pagination, getNextPage, appendData } =
		useFlatDataList<GroupMember>({}, 48);
	const { data, isLoading, refetch } = useGroupDetailMembersQuery(
		{ groupId, pagination },
		{ refetchOnMountOrArgChange: true },
	);

	useEffect(() => {
		appendData(data?.groupMembers?.data ?? []);
	}, [data]);

	return (
		<EArchivePatientList
			loadData={refetch}
			getNextPage={getNextPage}
			data={flatData}
			isLoading={isLoading}
			hasMoreData={data?.groupMembers?.meta?.hasNextPage || false}
			view={View.GRID}
			groupType={groupType}
		/>
	);
};

export default EArchiveGroupMembersList;
